import React, { useEffect } from 'react';
import { useIsAuthenticated } from "@azure/msal-react";
import { formatFinancialData } from './utils/chatUtils';
import useAuth from './hooks/useAuth';
import useChat from './hooks/useChat';
import { powerBIConfig } from './config';

// Component imports
import Navbar from './components/Navbar';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ChatPopup from './components/ChatPopup';

// Style imports
import './styles/App.css';

/**
 * Main App component
 * 
 * @returns {JSX.Element} App component
 */
function App() {
  const isAuthenticated = useIsAuthenticated();
  const { user, login, logout } = useAuth();
  const { 
    chatOpen, 
    messages, 
    userInput, 
    chatBodyRef, 
    toggleChat, 
    handleInputChange, 
    handleSend 
  } = useChat(user?.email); // Pass user email to useChat

  // Log when authentication state changes
  useEffect(() => {
    if (isAuthenticated && user) {
      console.log("User authenticated:", user.name);
    }
  }, [isAuthenticated, user]);

  // Render login screen if not authenticated
  if (!isAuthenticated) {
    return <Login onLogin={login} />;
  }
  return (
    <div className="app-container">
      <Navbar
        user={user?.name}
        role={user?.role}
        avatarUrl={user?.avatarUrl}
        initials={user?.initials}
        onLogout={logout}
      />
      
      <Dashboard 
        reportId={powerBIConfig.reportId} 
        ctid={powerBIConfig.ctid} 
      />
      
      <div className="chat-icon" onClick={toggleChat}>
        💬
      </div>
      
      <ChatPopup
        open={chatOpen}
        messages={messages}
        userInput={userInput}
        onInputChange={handleInputChange}
        onSend={handleSend}
        onClose={toggleChat}
        chatBodyRef={chatBodyRef}
        formatFinancialData={formatFinancialData}
      />
    </div>
  );
}

export default App;
